import {
  buildPageableParams,
  EtablissementDto,
  EtablissementProjection,
  Page,
  PageableArgs,
  servicesApi,
} from '@common/services';
import { EtablissementFichierType } from '@common/services/etablissement-fichier';
import { queryDownloadFile } from '../common/pageable/query-download-file';
import { EtablissementRuleInfoDto } from './types';

const ETABLISSEMENT_URL_PREFIX = 'etablissements';

const etablissementApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({

    getEtablissements: build.query<Page<EtablissementDto>, PageableArgs<EtablissementProjection>, any>({
      query: (args = {}) => ({
        url: ETABLISSEMENT_URL_PREFIX,
        params: buildPageableParams(args),
      }),
      providesTags: ['Etablissements'],
    }),

    getEtablissementRuleInfo: build.query<EtablissementRuleInfoDto, GetEtablissementRuleInfoArgs, any>({
      query: ({ siret }) => `${ETABLISSEMENT_URL_PREFIX}/rule/siret/${siret}`,
    }),

    exportEtablissementsFichiers: build.mutation<void, getExportsFichiersArgs, any>({
      queryFn: ({ anneeCampagne, ids, types }, _api, _extraOptions, baseQuery) => queryDownloadFile({
        baseQuery,
        url: `${ETABLISSEMENT_URL_PREFIX}/${anneeCampagne}/exports/fichiers`,
        params: { ids, types },
        defaultFilename: 'ExportFichier',
      }),
    }),

    exportEtablissementsFichiersForOrganisme: build.mutation<void, getExportsFichiersArgs, any>({
      queryFn: ({ anneeCampagne, ids, types }, _api, _extraOptions, baseQuery) => queryDownloadFile({
        baseQuery,
        url: `${ETABLISSEMENT_URL_PREFIX}/${anneeCampagne}/exports/fichiers/ofa`,
        params: { ids, types },
        defaultFilename: 'ExportFichier',
      }),
    }),

    getPourcentageEtablissementDeclarant: build.query<number, getPourcentageEtablissementDeclarantArgs, any>({
      query: ({ anneeCampagne }) => ({
        url: `${ETABLISSEMENT_URL_PREFIX}/${anneeCampagne}/pourcentage-etablissements-declarant-depot`,
      }),
      providesTags: ['Etablissements', 'Organismes'],
    }),
  }),
});

interface GetEtablissementRuleInfoArgs {
  siret: string;
}

interface getExportsFichiersArgs {
  anneeCampagne: number;
  ids: number[]; // ids des l'organismes
  types?: EtablissementFichierType[]; // types de fichiers à exporter (tous par défaut)
}

interface getPourcentageEtablissementDeclarantArgs {
  anneeCampagne: number;
}

export const {
  useGetEtablissementsQuery,
  useLazyGetEtablissementRuleInfoQuery,
  useExportEtablissementsFichiersMutation,
  useExportEtablissementsFichiersForOrganismeMutation,
  useGetPourcentageEtablissementDeclarantQuery,
} = etablissementApi;